import { searchOfficesBySlugName } from '@/database/algolia/methods';
import { getAlgoliaAPIKeyForSearchSlugOnOfficesRequest } from '@/database/firebase/API';

export const getOfficeBySlugName = async (officeName: string) => {
  const apiKeyResponse
    = await getAlgoliaAPIKeyForSearchSlugOnOfficesRequest(officeName);
  const matches = await searchOfficesBySlugName(apiKeyResponse.key);
  return !matches.length ? undefined : matches[0];
};
